export const SELECTOR_LABEL = 'Fase Selecionada';
